import { CustomEvent } from '@piwikpro/react-piwik-pro'

export const recordMintEvent = (type: 'mint_navbar' | 'mint_trigger' | 'mint_homepage') => {
    CustomEvent.trackEvent('mint_event', 'clicked', type);
}